module.exports = __webpack_public_path__ + "6c4a0dbc/img/question-icon.06c20c5d.svg";